import { createSlice } from "@reduxjs/toolkit";
import {
  getPhases,
  addNewPhase,
  updatePhase,
  deletePhase,
  getPhaseById,
  getPhaseBlockById,
} from "./thunk";

export const initialState = {
  phases: [],
  phaseBlocks: [],
  error: {},
  selectedPhase: null,
  isPhaseSuccess: false,
  isPhaseCreated: false,
};

const phasesSlice = createSlice({
  name: "PhasesSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Fetch phases
    builder.addCase(getPhases.fulfilled, (state, action) => {
      state.phases = action.payload; // Assuming `action.payload` contains phase data
      state.isPhaseSuccess = true;
      state.error = null;
    });

    builder.addCase(getPhases.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to fetch phases";
      state.isPhaseSuccess = false;
    });
    // Fetch a single phase by ID
    builder.addCase(getPhaseById.fulfilled, (state, action) => {
      state.selectedPhase = action.payload; // Set the selected phase
      state.error = null;
    });

    builder.addCase(getPhaseById.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to fetch phase by ID";
      state.selectedPhase = null; // Clear the selected phase on failure
    });

     // Fetch a phase blocks by ID
     builder.addCase(getPhaseBlockById.fulfilled, (state, action) => {
      state.phaseBlocks = action.payload; // Set the selected phase
      state.error = null;
    });

    builder.addCase(getPhaseBlockById.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to fetch phase by ID";
      // state.selectedPhase = null; // Clear the selected phase on failure
    });

    // Add new phase
    builder.addCase(addNewPhase.fulfilled, (state, action) => {
      state.phases.push(action.payload); // Add the new phase to the list
      state.isPhaseCreated = true;
      state.error = null;
    });

    builder.addCase(addNewPhase.rejected, (state, action) => {
      state.error = action.payload || "Failed to add phase";
      state.isPhaseCreated = false;
    });

    // Update phase
    builder.addCase(updatePhase.fulfilled, (state, action) => {
      state.phases = state.phases.map((phase) =>
        phase.id === action.payload.id ? { ...phase, ...action.payload } : phase
      );
      state.error = null;
    });
    

    builder.addCase(updatePhase.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to update phase";
    });

    // Delete phase
    builder.addCase(deletePhase.fulfilled, (state, action) => {
      state.phases = state.phases.filter(
        (phase) => phase.id !== action.payload.phaseId
      );
      state.error = null;
    });

    builder.addCase(deletePhase.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to delete phase";
    });
  },
});

export default phasesSlice.reducer;
